// Age helpers for the date-of-birth signup field and the 18+ practice-call gate.

// Whole years between an ISO YYYY-MM-DD date of birth and today.
// Returns null for an empty/invalid value.
export function ageFromDob(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age -= 1;
  return age;
}

// Today's date as an ISO YYYY-MM-DD string — handy for a date input's `max`.
export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}
